import React from 'react';
import {
  LayoutDashboard, BarChart3, LineChart, PieChart, ScanLine,
  FileText, Files, Database, Table, TableProperties,
  Store, Users, UserCog, User, Building2, Building,
  ClipboardList, ClipboardCheck, Calendar, CalendarDays, Clock,
  Settings, Sliders, Wrench, Cog,
  Truck, UtensilsCrossed, ShoppingBag, Tag,
  FileBarChart2, TrendingUp, Target, Award, Zap,
  FileStack, FileCheck, FileClock, FileSearch,
  Bell, Shield, Key, LogOut, LogIn,
  Mail, MessageSquare, Globe, Map, MapPin,
  BookOpen, Book, HelpCircle, Info,
  ArrowRightLeft, Sparkles, Brain, Activity,
  ChevronRight, ChevronLeft, ChevronDown, ChevronUp,
  Search, Home, Grid3x3, Layers,
  AlertTriangle, Flame, Package, Receipt,
  CheckCircle2, Circle, Dot,
  Moon, Sun, Monitor, ExternalLink,
} from 'lucide-react';

/**
 * Maps legacy V2 icon strings (from MenuAdmin/MenuCustom/MenuSadmin/MenuTenant data)
 * to Lucide React icon components. Unknown icons fall back to Circle.
 */
const MAP = {
  // Legacy V2 icon strings (match case-insensitively)
  charts: BarChart3,
  chart: BarChart3,
  analytics: LineChart,
  knowledgebase: BookOpen,
  book: BookOpen,
  table: Table,
  tables: Table,
  datatable: TableProperties,
  datagrid: Grid3x3,
  'data-grid': Grid3x3,
  file: FileText,
  files: Files,
  folder: FileStack,
  report: FileBarChart2,
  reports: FileBarChart2,
  revenuereports: FileBarChart2,
  dashboard: LayoutDashboard,
  sales: TrendingUp,
  tenant: Store,
  tenants: Store,
  traffic: Activity,
  footfall: Users,
  audit: ClipboardCheck,
  auditlog: ClipboardList,
  log: FileText,
  logs: FileText,
  errorlog: AlertTriangle,
  deletelog: FileClock,
  settings: Settings,
  generalsettings: Sliders,
  adminsettings: Cog,
  configurations: Wrench,
  config: Cog,
  concessionaire: Building2,
  property: Building,
  properties: Building,
  floor: Layers,
  category: Tag,
  subcategory: Tag,
  country: Globe,
  // Links that leave the app entirely — the icon is the only warning
  // the user gets before a new tab opens.
  'external-link': ExternalLink,
  user: User,
  users: Users,
  usertype: UserCog,
  permissions: Shield,
  permission: Shield,
  calendar: Calendar,
  time: Clock,
  schedule: Clock,
  schedulereports: FileClock,
  dynamicreports: FileStack,
  form: FileText,
  email: Mail,
  mail: Mail,
  message: MessageSquare,
  apikey: Key,
  key: Key,
  tenantportal: Store,
  more: HelpCircle,
  notification: Bell,
  home: Home,
  deliverypartner: Truck,
  fb: UtensilsCrossed,
  'fb-dashboard': UtensilsCrossed,
  anomaly: AlertTriangle,
  'alert-triangle': AlertTriangle,
  license: ClipboardCheck,
  licenses: ClipboardCheck,
  compare: ArrowRightLeft,
  comparison: ArrowRightLeft,
  spatial: Map,
  ai: Sparkles,
  brain: Brain,
  insight: Sparkles,
  // Legacy V2 icon strings that previously fell back to Circle
  'to-do': ClipboardList,
  'landing-page': Grid3x3,
  internationalization: Globe,
  widget: Store,
  builders: Activity,
  social: FileText,
  button: LogIn,
  project: FileStack,
  others: FileClock,
};

/**
 * Resolve a legacy icon name -> Lucide component.
 * Accepts arbitrary icon strings; falls back to Circle if unknown.
 */
export function resolveIcon(name, size = 16, strokeWidth = 1.75) {
  if (!name) return <Circle size={size} strokeWidth={strokeWidth} />;
  const Icon = MAP[String(name).toLowerCase()] || Circle;
  return <Icon size={size} strokeWidth={strokeWidth} />;
}

export {
  LayoutDashboard, BarChart3, LineChart, PieChart,
  FileText, Files, Table,
  Store, Users, User, Building2, Building,
  ClipboardCheck, Calendar, Settings, Sliders, Wrench,
  Bell, Shield, Key, LogOut,
  ChevronRight, ChevronLeft, ChevronDown, ChevronUp,
  Search, Home, Grid3x3, Layers,
  AlertTriangle, Sparkles, Brain, Activity,
  ArrowRightLeft, Map,
  Moon, Sun, Monitor,
  Globe,
};
